import { useTranslation } from "react-i18next";
import { InputField } from "ui-components";
interface EssayType {
  data?: any;
  setEssayTypeValue: any;
  essayTypeValue: any;
  startQuestionLoader: boolean;
  essayCharCount: any;
  setEssayCharCount: any;
}
const characterLimit = 1000;

const EssayType: React.FC<EssayType> = ({
  setEssayTypeValue,
  essayTypeValue,
  startQuestionLoader,
  essayCharCount,
  setEssayCharCount,
}) => {
  const { t } = useTranslation();
  const handleInputChange = (id: any, value: any) => {
    setEssayTypeValue(value);
    setEssayCharCount(value.length);
  };

  return (
    <div
      style={{
        pointerEvents: startQuestionLoader ? "none" : "auto",
      }}
      className="essayType"
    >
      <InputField
        additionalProps={{
          as: "textarea",
          rows: 12,
          style: { resize: "none" },
          // disabled: startQuestionLoader ? true : false,
        }}
        value={essayTypeValue}
        placeholder={t("GENERAL.PLACEHOLDER")}
        onChange={(e) => handleInputChange(null, e)}
      />
      <div
        className={
          essayTypeValue.length > characterLimit
            ? "EssayLimitAccessCssOver limitAccess"
            : "limitAccess"
        }
      >
        <p className={"charLimitMsg"}>
          {t("GENERAL.MUST_BE_LESS_THAN")} {characterLimit}{" "}
          {t("GENERAL.CHARACTERS")}
        </p>
        {essayCharCount > 0 && (
          <p className="charLimit">
            {essayCharCount <= characterLimit
              ? characterLimit - essayCharCount
              : `-${essayCharCount - characterLimit}`}
            &nbsp;
            {t("SUBMIT_ASSESSMENT.TEXT_EDITOR_LIMIT")}
          </p>
        )}
      </div>
    </div>
  );
};

export default EssayType;
